import React from "react";
import { motion } from "framer-motion";
import { CONDITIONS } from "../content";

export default function Conditions() {
  return (
    <section
      id="conditions"
      data-testid="conditions-section"
      className="relative section-pad"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <div className="text-[#27C6FF] uppercase tracking-[0.3em] text-xs mb-5 font-heading">
              Conditions We Help With
            </div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
              Clinical care for the
              <br />
              <span className="gradient-text">issues that hold you back.</span>
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="lg:col-span-5 text-[#D8CCFF] text-base md:text-lg font-body"
          >
            From hormonal and metabolic issues to the emotional patterns
            around food — every plan is built on your bloodwork, history and
            real life.
          </motion.p>
        </div>

        <div className="mt-14 flex flex-wrap gap-3" data-testid="conditions-grid">
          {CONDITIONS.map((c, i) => (
            <motion.div
              key={c}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.4, delay: i * 0.04 }}
              whileHover={{ y: -4 }}
              className="glass rounded-full px-5 py-3 text-sm md:text-base text-[#F5F3FF] font-heading font-medium hover:border-[#27C6FF] hover:text-[#27C6FF] hover:shadow-[0_0_30px_rgba(39,198,255,0.35)] transition-all duration-300 cursor-default"
              data-testid={`condition-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              {c}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
